import { useState } from "react";
import "./Faq.css";

export default function Faq({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="faq">
      {items.map((item, i) => (
        <div className={`faq__item ${open === i ? "is-open" : ""}`} key={item.q}>
          <button
            className="faq__q"
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
          >
            <span>{item.q}</span>
            <span className="faq__icon" aria-hidden="true">+</span>
          </button>
          {/* Answer stays in the DOM (collapsed via CSS) so crawlers always read it. */}
          <div className="faq__a">
            <div className="faq__a-inner">{item.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
